import React, { useEffect, useState } from "react";
import { X, History, Clock, Smartphone } from "lucide-react";
import { api } from "@/lib/api";
import { formatDate, summarizeUA } from "./userUtils";

export default function LoginHistoryModal({ user, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get(`/users/${user.id}/login-history?limit=30`).then((r) => setRows(r.data.rows || [])).catch(() => setRows([]));
  }, [user.id]);

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-4" data-testid="login-history-modal">
      <div className="bg-white rounded-xl shadow-xl border border-slate-200 w-full max-w-lg">
        <div className="p-5 border-b border-slate-200 flex items-center justify-between">
          <div>
            <h3 className="font-display text-lg font-bold flex items-center gap-2">
              <History size={18} /> Giriş Geçmişi
            </h3>
            <p className="text-xs text-slate-500 font-mono-tab mt-0.5">{user.email}</p>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={16} /></button>
        </div>
        <div className="max-h-[60vh] overflow-y-auto">
          {rows === null && <div className="py-10 text-center text-slate-400 text-sm">Yükleniyor...</div>}
          {rows && rows.length === 0 && <div className="py-10 text-center text-slate-400 text-sm">Henüz giriş kaydı yok</div>}
          {rows && rows.length > 0 && (
            <div className="divide-y divide-slate-100">
              {rows.map((r, i) => (
                <div key={r.id || i} className="p-4 flex items-start gap-3">
                  <div className="shrink-0 w-8 h-8 rounded-lg bg-emerald-100 text-emerald-700 grid place-items-center">
                    <Clock size={13} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-mono-tab text-xs font-semibold text-slate-900">{formatDate(r.at)}</div>
                    <div className="text-xs text-slate-600 mt-0.5 flex items-center gap-1">
                      <Smartphone size={10} /> {summarizeUA(r.user_agent)}
                    </div>
                    {r.ip && <div className="text-[11px] font-mono-tab text-slate-400 mt-0.5">{r.ip}</div>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
